var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Field } from 'vant';
import { isNotEmpty } from '@lhb/func';
var SubcontractInput = /** @class */ (function (_super) {
    __extends(SubcontractInput, _super);
    function SubcontractInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SubcontractInput.prototype, "curMax", {
        // 设置属性默认值
        get: function () {
            if (['digit', 'number'].includes(this.type)) {
                return isNotEmpty(this.max) ? this.max : 99999999999.99; // 为了兼容手机号码的长度
            }
            return this.max;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubcontractInput.prototype, "isDiffNumber", {
        // 设置属性默认值
        get: function () {
            if (['digit', 'number'].includes(this.type)) {
                if (isNotEmpty(this.curMax) && this.curMax < 0) { // 只要有设置小于0的最大值就是特殊控件
                    return true;
                }
                else if (isNotEmpty(this.min)) { // 只要有最小值，就是特殊控件
                    return true;
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubcontractInput.prototype, "textAttrs", {
        // 设置属性默认值
        get: function () {
            var extraConfig = {};
            if (this.isDiffNumber) { // 只要是特殊控件，就不能用数字类键盘，需要用文本
                extraConfig.type = 'text';
            }
            return Object.assign({ clearable: true }, this.$attrs, this.$props, extraConfig);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SubcontractInput.prototype, "$target", {
        get: function () {
            return this.$refs.target;
        },
        enumerable: false,
        configurable: true
    });
    SubcontractInput.prototype.formatterFunc = function (value) {
        if (this.ignoreFormatter)
            return value;
        if (['digit', 'number'].includes(this.type)) {
            if (this.isFloat) { // 输入是浮点数时候
                value = value.replace(/[^\d\.]/g, '');
                if (value) {
                    var _value = value.split('.');
                    if (_value.length === 3) {
                        if (value.slice(-1) === '.') {
                            value = value.slice(0, -1);
                        }
                        else {
                            return null;
                        }
                    }
                    else if (_value.length > 3) {
                        return null;
                    }
                    else {
                        // 处理浮点长度
                        if (_value[1] && _value[1].length > this.floatLength) {
                            value = value.slice(0, value.length - (_value[1].length - this.floatLength));
                        }
                    }
                }
            }
            if (this.limitBeginningRepeatZero && value) {
                var arr = value.split('.');
                if (arr.length < 2 || (arr[0].length > 1 && +arr[1])) {
                    value = +value;
                }
                if (arr.length === 2 && arr[0].length > 1 && !+arr[1]) {
                    value = value.replace(/^0+([1-9]*)\./, function (_match, first) {
                        return first ? first + "." : "0" + first + ".";
                    });
                }
            }
            // 控制在最大值内
            if (value && this.curMax && +value > +this.curMax) {
                value = this.curMax;
            }
        }
        return value;
    };
    SubcontractInput.prototype.onInput = function (e) {
        this.$emit('input', e);
    };
    SubcontractInput.prototype.onBlur = function (e) {
        if (this.isDiffNumber && !this.ignoreFormatter) { // 特殊控件只触发onBlur，不事实替换value
            var _precision = this.floatLength;
            var lastValue = void 0;
            if (isNaN(parseFloat(this.value))) {
                lastValue = '';
            }
            else {
                lastValue = String(parseFloat(this.value)).replace(/[^\d.-]/g, '')
                    .replace(/^\./, '') // 删除首字符为点的情况
                    .replace(/(?!^-)-/g, '')
                    .replace(/(\..*)\./g, '$1');
            }
            if (isNotEmpty(lastValue)) {
                var start = lastValue + '';
                if (start.indexOf('.') > -1) { // 当有小数点时，需要尝试做2次矫正。疑问ant的input-number组件有 bug。两次输入 . 之后就不会再正常渲染
                    var list = start.split('.');
                    var res = '';
                    if (_precision) { // 大于0个
                        if (list[1]) {
                            res = list[0] + '.' + list[1].slice(0, _precision);
                        }
                    }
                    else {
                        res = list[0];
                    }
                    if (res !== start) {
                        lastValue = res;
                    }
                }
                if (isNotEmpty(this.curMax) && +lastValue > +this.curMax) {
                    lastValue = this.curMax;
                }
                if (isNotEmpty(this.min) && +lastValue < +this.min) {
                    lastValue = this.min;
                }
            }
            this.$emit('input', lastValue ? +lastValue : lastValue);
        }
        this.$emit('blur', e);
    };
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], SubcontractInput.prototype, "label", void 0);
    __decorate([
        Prop({
            type: [String, Number],
            default: ''
        })
    ], SubcontractInput.prototype, "value", void 0);
    __decorate([
        Prop({
            type: String,
            default: 'text'
        })
    ], SubcontractInput.prototype, "type", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], SubcontractInput.prototype, "isFloat", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 2
        })
    ], SubcontractInput.prototype, "floatLength", void 0);
    __decorate([
        Prop({
            type: [String, Number],
            default: ''
        })
    ], SubcontractInput.prototype, "max", void 0);
    __decorate([
        Prop({
            type: [String, Number],
            default: ''
        })
    ], SubcontractInput.prototype, "min", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: true
        })
    ], SubcontractInput.prototype, "limitBeginningRepeatZero", void 0);
    __decorate([
        Prop({
            type: String,
            default: 'onChange'
        })
    ], SubcontractInput.prototype, "formatTrigger", void 0);
    __decorate([
        Prop({
            type: String,
            default: ''
        })
    ], SubcontractInput.prototype, "placeholder", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], SubcontractInput.prototype, "required", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () { return []; }
        })
    ], SubcontractInput.prototype, "rules", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], SubcontractInput.prototype, "ignoreFormatter", void 0);
    SubcontractInput = __decorate([
        Component({
            components: {
                VanField: Field
            }
        })
    ], SubcontractInput);
    return SubcontractInput;
}(Vue));
export default SubcontractInput;
